module.exports = __webpack_public_path__ + "img/dpd_manual.88d9ab9c.jpg";